App.directive('cookiesTpl', ['$window', '$cookies', function ($window, $cookies) {
    return {
        restrict: 'AEC',
        scope: {

        },
        templateUrl: 'Templates/cookies-tpl.html',
        link: function(scope) {
            scope.isAccept = $cookies.get('accept');

        	scope.accept = function() {
				$cookies.put('accept', true);
				scope.isAccept = $cookies.get('accept');
                $('.bottominfo').css({'bottom': '0px'});
		   	}
        }
    };
}]);